const footer = {
    location: 'Beer-Sheva, Israel',
    myName: 'Tomer Halali',
    navigate: 'Navigate',
    reach: 'Reach me',
    elsewhere: 'Elsewhere',
    builtWith: 'React · TypeScript · SCSS',
};

export default footer;
